const config = {
  server: {
    // Application host
    host: '%REACT_APP_HOST%',
    // Application path - every route will be prefixed with this path
    path: '%PUBLIC_URL%'
  },
  oktaOIDC: {
    clientId: '%REACT_APP_OKTA_CLIENT_ID%',
    samlId: `%REACT_APP_OKTA_SAML_ID%`,
    issuerPath: '%REACT_APP_OKTA_ISSUER_PATH%',
    redirectUri: '%REACT_APP_OKTA_REDIRECT_URI%',
    baseUrl: '%REACT_APP_OKTA_BASE_URL%',
    scope: ['openid', 'email', 'profile']
  },
  asset: {
    host: '%REACT_APP_assetHost%',
    path: '%REACT_APP_assetPath%',
    videoContentPath: '%REACT_APP_assetVideoContentPath%'
  },
  // eslint-disable-next-line camelcase
  asset_imagepresets: {
    pngicon: '$IconImagePresetforPNG$',
    jpegimage: '$ResponsiveImagePresetForJPEG$'
  },
  imageSize: ['(max-width: 320px) 320px', '800px'],
  srcSet: {
    smallRend: '320w',
    largeRend: '800w'
  },
  breakpoint: {
    small: '320',
    large: '800'
  },
  weightMapping: { digitsAfterDecimal: '3' },
  shouldCheckTnC: false,
  login: {
    entry: '/login',
    redirectAfterLogin: '/dashboard',
    redirectAfterLogout: '/login'
  },
  tnc: {
    entry: '/tnc',
    redirectAfterLogin: '/dashboard',
    redirectAfterLogout: '/login'
  },
  products: {
    entry: '/products',
    overview: '/overview'
  },
  locale: {
    lang: 'en',
    country: 'us',
    timeZone: '',
    localeString: 'en'
  },
  urlSettings: {
    locale: {
      lang: true,
      country: true
    }
  },
  region: 'VNGOSC',
  toast: {
    autoClose: 5000
  },
  inlineTranslations: {
    en: {
      500: 'Sorry! Some of the requests failed. Please try again later.',
      404: 'Sorry! The request was not found. Please try again later.',
      400: 'Sorry! The request was not submitted successfully. Please try again later.',
      default: 'An error occurred!',
      localeDateStr: 'M/D',
      accountContextMsg: `Your account is being set-up. Once completed, 
    our team will reach out to confirm you are now ready to log into myCargill.com. 
    Please, reach out to your sales representative for immediate assistance.`
    },
    es: {
      500: '¡Lo sentimos! Alguna de las solicitudes falló. Por favor, intente más tarde.',
      404: '¡Lo sentimos! No se encontró la solicitud. Por favor, Intente más tarde.',
      400: '¡Lo sentimos! Su solicitud no fue enviada correctamente. Por favor, intente más tarde.',
      default: 'Un error ha ocurrido!',
      localeDateStr: 'D/M',
      accountContextMsg: `Una vez completada, nuestro equipo se comunicará con usted para confirmar que su cuenta esta lista para iniciar sesión en myCargill.com. 
      Comuníquese con su representante de ventas para obtener asistencia inmediata.`
    },
    pt: {
      500: 'Desculpe! Algumas requisições falharam. Por favor, tente novamente mais tarde.',
      404: 'Desculpe! A requisição não foi encontrada. Por favor, tente novamente mais tarde.',
      400: 'Desculpe! A requisição não foi enviada com sucesso. Por favor, tente novamente mais tarde.',
      default: 'Ocorreu um erro!',
      localeDateStr: 'D/M',
      accountContextMsg: `Sua conta está sendo configurada. 
      Depois de concluído, nossa equipe entrará em contato para confirmar que você está pronto para fazer login no myCargill.com. 
      Entre em contato com seu representante de vendas para obter assistência imediata.`
    }
  },
  permissionDeniedLabels: {
    en: {
      title: "Access Denied. It seems you don't have the necessary permissions to view this content.",
      subTitle: 'Please reach out to your customer account coordinator if you need access.',
      buttonBack: 'Back to Dashboard'
    },
    es: {
      title: 'Acceso denegado. Parece que no tienes los permisos necesarios para ver este contenido.',
      subTitle: 'Comuníquese con su coordinador de cuenta de cliente si necesita acceso.',
      buttonBack: 'Volver al tablero'
    },
    pt: {
      title: 'Acesso negado. Parece que você não tem as permissões necessárias para visualizar este conteúdo.',
      subTitle: 'Entre em contato com o coordenador da sua conta de cliente se precisar de acesso.',
      buttonBack: 'Voltar ao painel de controle'
    }
  },
  defaultMeasuringUnit: 'MT',
  apiWrapperConfig: {
    apiTimeout: 60000
  },
  searchType: {
    products: 'products'
  },
  breadcrumbNames: {
    en: {
      dashboard: 'Dashboard',
      orders: 'Orders',
      orderbuilder: 'Place Order',
      products: 'Products',
      contracts: 'Contracts',
      documents: 'Documents',
      technicaldocuments: 'Technical Documents',
      productdocuments: 'Product Documents',
      review: 'Review & Checkout',
      confirmation: 'Confirmation',
      support: 'Support',
      faq: 'Frequently Asked Questions (FAQs)',
      requestsample: 'Request a Sample',
      marketinsight: 'Market Ticker',
      customerrequests: 'My Requests',
      users: 'User Management',
      bulkusermanagement: 'Bulk User Management',
      myprofile: 'User Profile',
      documententitlement: 'Document Entitlements',
      placeordercontractdata: 'Place Order Contract Data',
      profile: 'Profile',
      accounts: 'Accounts',
      accountAssociation: 'Sold To/Ship To Associations',
      permissions: 'Permissions'
    },
    es: {
      dashboard: 'Tablero',
      orders: 'Pedidos',
      orderbuilder: 'Realizar Pedido',
      products: 'Productos',
      contracts: 'Contratos',
      documents: 'Documentos',
      technicaldocuments: 'Documentos Técnicos',
      productdocuments: 'Documentos del Producto',
      review: 'Revisar & Verificar',
      confirmation: 'Confirmación',
      support: 'Apoyo',
      faq: 'Preguntas Frecuentes (FAQs)',
      requestsample: 'Solicitar una Muestra',
      marketinsight: 'Ticker del Mercado',
      customerrequests: 'Mis Solicitudes',
      users: 'Gestión de Usuarios',
      bulkusermanagement: 'Gestión Masiva de Usuarios',
      myprofile: 'Perfil del Usuario',
      documententitlement: 'Derechos de los Documentos',
      placeordercontractdata: 'Datos para Creación de Pedidos',
      profile: 'Perfil',
      accounts: 'Cuentas',
      accountAssociation: 'Sold To/Ship To Associations',
      permissions: 'Permisos'
    },
    pt: {
      dashboard: 'Painel',
      orders: 'Pedidos',
      orderbuilder: 'Fazer Novo Pedido',
      products: 'Produtos',
      contracts: 'Contratos',
      documents: 'Documentos',
      technicaldocuments: 'Documentos Técnicos',
      productdocuments: 'Documentos do Produto',
      review: 'Revisão e Check-out',
      confirmation: 'Confirmação',
      support: 'Suporte',
      faq: 'Perguntas e Respostas Frequentes (FAQs)',
      requestsample: 'Solicite Uma Amostra',
      marketinsight: 'Indicadores de Mercado',
      customerrequests: 'Minhas Solicitações',
      users: 'Gestão de Usuários',
      bulkusermanagement: 'Gerenciamento de Usuários em Massa',
      myprofile: 'Perfil de Usuário',
      documententitlement: 'Direitos do Documento',
      placeordercontractdata: 'Dados para Criação de Pedidos'
    },
    customTranslations: {
      en: {
        review: 'Review'
      },
      es: {
        review: 'Revisar'
      },
      pt: {
        review: 'Revisar'
      }
    }
  },
  loaderTime: 500,
  debounceTime: 500,
  // eslint-disable-next-line camelcase
  login_session: {
    inactiveSessionDuration: 12000 // in seconds
  },
  oktaUserGroups: { internalUserGroup: 'DXP_Food_InternalUsers', externalUserGroup: 'DXP_Food_ExternalUsers' },
  log: {
    level: 'info',
    handler: 'http'
  },
  mappedSalesAreaDetails: [
    {
      salesAreas: ['1003-01-31', '1003-01-10', '1003-01-21', '1003-01-41', '1003-01-50'],
      flow: 'br'
    },
    {
      salesAreas: ['1121-01-30', '1121-01-20', '1121-01-18'],
      flow: 'mx'
    },
    {
      salesAreas: [
        '1001-01-21',
        '1109-01-20',
        '1001-01-18',
        '1019-01-18',
        '1019-01-21',
        '1001-01-22',
        '1019-01-22',
        '1001-01-20',
        '1019-01-20'
      ],
      flow: 'csstna'
    },
    {
      salesAreas: ['1001-01-30'],
      flow: 'eosna'
    },
    {
      salesAreas: ['1019-01-30'],
      flow: 'eosca'
    },
    {
      salesAreas: ['1015-01-10', '1019-01-10'],
      flow: 'ccna'
    }
  ],
  analyticsData: {
    pages: [
      {
        path: '/food/us/en/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/us/en/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/us/en/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/us/en/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/us/en/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/us/en/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/us/en/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/us/en/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/us/en/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/us/en/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/us/en/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/us/en/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/us/en/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/us/en/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/us/en/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/us/en/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/us/en/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/us/en/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/us/en/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/us/en/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/us/en/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/us/en/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/us/en/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/us/en/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/us/en/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/us/en/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/us/en/pages/sustainability/cocoa',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/us/en/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/us/en/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/us/en/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/us/en/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/us/en/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/us/en/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/us/en/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/us/en/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/us/en/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/us/en/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:users registration review'
      },
      {
        path: '/food/us/en/pages/customerrequests',
        description: 'Customer Request Center',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'United States',
        language: 'EN-US',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/mx/es/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/mx/es/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/mx/es/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/mx/es/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/mx/es/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/mx/es/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/mx/es/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/mx/es/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/mx/es/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/mx/es/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/mx/es/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/mx/es/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/es/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/es/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/es/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/es/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/mx/es/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/mx/es/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/mx/es/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/mx/es/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/mx/es/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/mx/es/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/mx/es/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/mx/es/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/mx/es/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/mx/es/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/mx/es/pages/customerrequests',
        description: 'Customer Request Center',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/sustainability/mx/es/pages/sustainability/cocoawise',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/mx/es/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/mx/es/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/mx/es/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/mx/es/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/mx/es/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/mx/es/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/mx/es/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/mx/es/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/mx/es/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/mx/es/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'ES-MX',
        pageName: 'mycargill:food:users registration review'
      },
      {
        path: '/food/mx/en/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/mx/en/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/mx/en/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/mx/en/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/mx/en/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/mx/en/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/mx/en/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/mx/en/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/mx/en/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/mx/en/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/mx/en/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/mx/en/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/en/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/en/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/en/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/mx/en/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/mx/en/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/mx/en/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/mx/en/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/mx/en/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/mx/en/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/mx/en/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/mx/en/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/mx/en/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/mx/en/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/mx/en/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/mx/en/pages/sustainability/cocoa',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/mx/en/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/mx/en/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/mx/en/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/mx/en/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/mx/en/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/mx/en/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/mx/en/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/mx/en/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/mx/en/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/mx/en/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:users registration review'
      },
      {
        path: '/food/mx/en/pages/customerrequests',
        description: 'Customer Request Center',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'Mexico',
        language: 'EN-MX',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/br/pt/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/br/pt/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/br/pt/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/br/pt/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/br/pt/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/br/pt/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/br/pt/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/br/pt/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/br/pt/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/br/pt/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/br/pt/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/br/pt/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/pt/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/pt/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/pt/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/pt/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/br/pt/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/br/pt/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/br/pt/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/br/pt/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/br/pt/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/br/pt/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/br/pt/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/br/pt/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/br/pt/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/br/pt/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/br/pt/pages/sustainability/cocoa',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/br/pt/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/br/pt/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/br/pt/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/br/pt/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/br/pt/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/br/pt/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/br/pt/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/br/pt/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/br/pt/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/br/pt/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:users registration review'
      },
      {
        path: '/food/br/pt/pages/customerrequests',
        description: 'Customer Request Center',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'PT-BR',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/br/en/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/br/en/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/br/en/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/br/en/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/br/en/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/br/en/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/br/en/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/br/en/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/br/en/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/br/en/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/br/en/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/br/en/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/en/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/en/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/en/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/en/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/br/en/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/br/en/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/br/en/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/br/en/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/br/en/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/br/en/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/br/en/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/br/en/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/br/en/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/br/en/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/br/en/pages/sustainability/cocoa',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/br/en/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/br/en/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/br/en/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/br/en/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/br/en/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/br/en/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/br/en/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/br/en/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/br/en/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/br/en/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:users registration review'
      },
      {
        path: '/food/br/en/pages/customerrequests',
        description: 'Customer Request Center',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'EN-BR',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/br/es/pages/login',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Login',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Login Page',
        pageName: 'mycargill:food:login'
      },
      {
        path: '/food/br/es/pages/dashboard',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Dashboard',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Dashboard',
        pageName: 'mycargill:food:dashboard'
      },
      {
        path: '/food/br/es/pages/support',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Support',
        pageName: 'mycargill:food:support'
      },
      {
        path: '/food/br/es/pages/support/faq',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ'
      },
      {
        path: '/food/br/es/pages/support/faq/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ documents'
      },
      {
        path: '/food/br/es/pages/support/faq/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ products'
      },
      {
        path: '/food/br/es/pages/support/faq/accountmanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ account management'
      },
      {
        path: '/food/br/es/pages/support/faq/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ orders'
      },
      {
        path: '/food/br/es/pages/support/faq/usermanagement',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Support',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:support FAQ user management'
      },
      {
        path: '/food/br/es/pages/tnc',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'TNC',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:tnc'
      },
      {
        path: '/food/br/es/pages/products/product/:productId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - View Product Description',
        pageName: 'mycargill:food:products:productSKU:product description'
      },
      {
        path: '/food/br/es/pages/products',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/es/pages/products/:custId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/es/pages/products/:custId/:catId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/es/pages/products/:custId/:catId/:subCatID',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Catalog',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - View Products',
        pageName: 'mycargill:food:products:view products'
      },
      {
        path: '/food/br/es/pages/requestsample',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sample',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Products - Request a Sample - Select Products',
        pageName: 'mycargill:food:request sample'
      },
      {
        path: '/food/br/es/pages/orders',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Orders - Order History',
        pageName: 'mycargill:food:orders:order history'
      },
      {
        path: '/food/br/es/pages/orders/:orderId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Order History',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Orders - Order History - Order Details',
        pageName: 'mycargill:food:orders:order history:order details'
      },
      {
        path: '/food/br/es/pages/orderbuilder',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Orders - Place Order - Place New Order - Choose Your Order Options',
        pageName: 'mycargill:food:orders:place order:place new order'
      },
      {
        path: '/food/br/es/pages/orderbuilder/confirmation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Orders',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Orders - Place Order - Order Confirmation',
        pageName: 'mycargill:food:orders:place order:order confirmation'
      },
      {
        path: '/food/br/es/pages/documents',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Documents',
        pageName: 'mycargill:food:documents'
      },
      {
        path: '/food/br/es/pages/documents/productdocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Documents - Product Documents',
        pageName: 'mycargill:food:documents:product'
      },
      {
        path: '/food/br/es/pages/documents/technicaldocuments',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Documents',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Documents - Technical Documents',
        pageName: 'mycargill:food:documents:technical'
      },
      {
        path: '/food/br/es/pages/marketinsight',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Market Ticker',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Market Ticker',
        pageName: 'mycargill:food:market ticker'
      },
      {
        path: '/food/br/es/pages/contracts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Contracts',
        pageName: 'mycargill:food:contracts'
      },
      {
        path: '/food/br/es/pages/contracts/:contractId',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Contracts',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Contracts - View Contract',
        pageName: 'mycargill:food:contracts:contracts details'
      },
      {
        path: '/food/br/es/pages/customerrequests',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Customer Request Center',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Customer Request Center',
        pageName: 'mycargill:food:customerrequests'
      },
      {
        path: '/food/sustainability/br/es/pages/sustainability/cocoawise',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Sustainability',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Sustainability',
        pageName: 'mycargill:food:sustainability'
      },
      {
        path: '/food/br/es/pages/myprofile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Profile',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'Profile',
        pageName: 'mycargill:food:profile'
      },
      {
        path: '/food/br/es/pages/users',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        description: 'User Management',
        pageName: 'mycargill:food:users'
      },
      {
        path: '/food/br/es/pages/users/activation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users activation'
      },
      {
        path: '/food/br/es/pages/users/activation/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'User Management',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:profile',
        description: 'Profile'
      },
      {
        path: '/food/br/es/pages/users/registration',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration'
      },
      {
        path: '/food/br/es/pages/users/registration/:key/profile',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration profile'
      },
      {
        path: '/food/br/es/pages/users/registration/:key/accounts',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration account'
      },
      {
        path: '/food/br/es/pages/users/registration/:key/accountAssociation',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration account association'
      },
      {
        path: '/food/br/es/pages/users/registration/:key/permissions',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration permissions'
      },
      {
        path: '/food/br/es/pages/users/registration/:key/review',
        experienceCategory: 'Customer Portal',
        experienceProduct: 'Food',
        capability: 'Users',
        productRegion: 'NA',
        country: 'Brazil',
        language: 'ES-BR',
        pageName: 'mycargill:food:users registration review'
      }
    ]
  },
  currencyMapping: {
    FJD: 'FJD',
    MXN: 'MXN',
    STD: 'STD',
    LVL: 'LVL',
    SCR: 'SCR',
    CDF: 'CDF',
    BBD: 'BBD',
    HNL: 'HNL',
    UGX: 'UGX',
    ZAR: 'ZAR',
    BSD: 'BSD',
    SDD: 'SDD',
    ZRN: 'ZRN',
    IQD: 'IQD',
    SDP: 'SDP',
    CUP: 'CUP',
    GMD: 'GMD',
    TWD: 'TWD',
    MYO: 'MYO',
    RSD: 'RSD',
    MYR: 'MYR',
    FKP: 'FKP',
    TWO: 'TWO',
    XOF: 'XOF',
    UYU: 'UYU',
    CVE: 'CVE',
    TRYN: 'TRYN',
    OMR: 'OMR',
    GBPN: 'GBPN',
    KES: 'KES',
    SEK: 'SEK',
    BTN: 'BTN',
    GNF: 'GNF',
    MZN: 'MZN',
    MZM: 'MZM',
    SVC: 'SVC',
    ARS: 'ARS',
    QAR: 'QAR',
    digitsAfterDecimal: '2',
    IRR: 'IRR',
    NLG: 'NLG',
    CFP: 'CFP',
    THA: 'THA',
    THB: 'THB',
    UZS: 'UZS',
    XPF: 'XPF',
    ARSN: 'ARSN',
    BDT: 'BDT',
    LYD: 'LYD',
    KWD: 'KWD',
    RUB: 'RUB',
    ISK: 'ISK',
    BEF: 'BEF',
    MKD: 'MKD',
    DZD: 'DZD',
    PAB: 'PAB',
    SGD: 'SGD',
    KGS: 'KGS',
    XAF: 'XAF',
    ATS: 'ATS',
    CHF: 'CHF',
    HRK: 'HRK',
    ITL: 'ITL',
    DJF: 'DJF',
    TZS: 'TZS',
    ADP: 'ADP',
    VND: 'VND',
    MXNN: 'MXNN',
    AUD: 'AUD',
    KHR: 'KHR',
    IDO: 'IDO',
    IDR: 'IDR',
    VNO: 'VNO',
    KYD: 'KYD',
    PLNN: 'PLNN',
    BWP: 'BWP',
    SHP: 'SHP',
    CYP: 'CYP',
    TJS: 'TJS',
    TJR: 'TJR',
    AED: 'AED',
    RWF: 'RWF',
    DKK: 'DKK',
    ZWD: 'ZWD',
    BGN: 'BGN',
    MMK: 'MMK',
    NOK: 'NOK',
    SYP: 'SYP',
    ZWL: 'ZWL',
    YUM: 'YUM',
    LKR: 'LKR',
    CZK: 'CZK',
    IEP: 'IEP',
    HUFN: 'HUFN',
    GRD: 'GRD',
    XCD: 'XCD',
    HTG: 'HTG',
    AFA: 'AFA',
    BHD: 'BHD',
    SIT: 'SIT',
    PTE: 'PTE',
    KZT: 'KZT',
    SZL: 'SZL',
    YER: 'YER',
    AFN: 'AFN',
    BYB: 'BYB',
    EURN: 'EURN',
    AWG: 'AWG',
    NPR: 'NPR',
    MNT: 'MNT',
    GBP: 'GBP',
    HUF: 'HUF',
    BYR: 'BYR',
    BIF: 'BIF',
    XDS: 'XDS',
    BZD: 'BZD',
    MOP: 'MOP',
    NAD: 'NAD',
    SKK: 'SKK',
    TMM: 'TMM',
    PEN: 'PEN',
    WST: 'WST',
    FRF: 'FRF',
    GTQ: 'GTQ',
    CLP: 'CLP',
    XEU: 'XEU',
    TND: 'TND',
    SLL: 'SLL',
    SEKN: 'SEKN',
    DOP: 'DOP',
    KMF: 'KMF',
    GEL: 'GEL',
    MAD: 'MAD',
    AZM: 'AZM',
    TOP: 'TOP',
    PGK: 'PGK',
    digitsAfterDecimalUnitPrice: '5',
    CNH: 'CNH',
    UAH: 'UAH',
    ERN: 'ERN',
    CNO: 'CNO',
    TPE: 'TPE',
    MRO: 'MRO',
    CNY: 'CNY',
    PHO: 'PHO',
    BMD: 'BMD',
    PHP: 'PHP',
    PYG: 'PYG',
    JMD: 'JMD',
    GWP: 'GWP',
    ESP: 'ESP',
    COP: 'COP',
    RMB: 'RMB',
    USD: 'USD',
    ETB: 'ETB',
    VEB: 'VEB',
    ECS: 'ECS',
    SOS: 'SOS',
    VEF: 'VEF',
    VUV: 'VUV',
    CADN: 'CADN',
    LAK: 'LAK',
    BND: 'BND',
    ZMK: 'ZMK',
    LRD: 'LRD',
    ALL: 'ALL',
    GHC: 'GHC',
    MTL: 'MTL',
    ZMW: 'ZMW',
    TRL: 'TRL',
    USDN: 'USDN',
    ILS: 'ILS',
    GHS: 'GHS',
    GYD: 'GYD',
    KPW: 'KPW',
    BOB: 'BOB',
    MDL: 'MDL',
    AMD: 'AMD',
    TRY: 'TRY',
    LBP: 'LBP',
    JOD: 'JOD',
    AUDN: 'AUDN',
    HKD: 'HKD',
    EUR: 'EUR',
    LSL: 'LSL',
    CAD: 'CAD',
    EEK: 'EEK',
    MUR: 'MUR',
    ROL: 'ROL',
    GIP: 'GIP',
    RON: 'RON',
    NGN: 'NGN',
    CRC: 'CRC',
    PKR: 'PKR',
    ANG: 'ANG',
    SRD: 'SRD',
    LTL: 'LTL',
    SAR: 'SAR',
    TTD: 'TTD',
    MVR: 'MVR',
    KRO: 'KRO',
    SRG: 'SRG',
    INO: 'INO',
    INR: 'INR',
    BRLN: 'BRLN',
    KRW: 'KRW',
    JPY: 'JPY',
    AOA: 'AOA',
    PLN: 'PLN',
    SBD: 'SBD',
    CSD: 'CSD',
    DEM3: 'DEM3',
    LUF: 'LUF',
    AON: 'AON',
    MWK: 'MWK',
    AOR: 'AOR',
    MGA: 'MGA',
    FIM: 'FIM',
    DEM: 'DEM',
    MGF: 'MGF',
    BAM: 'BAM',
    EGP: 'EGP',
    SSP: 'SSP',
    CHFN: 'CHFN',
    NIO: 'NIO',
    NZD: 'NZD',
    BRL: 'BRL'
  }
};

export default config;
